import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import path from 'path';
let configPath;
// Load the correct config - prod config is editable after packaging, dev path one isn't
if (process.env.NODE_ENV !== 'production') {
    console.log('dev mode');
    configPath = path.join(__dirname, '/config/config.json');
} else {
    console.log('prod mode');
    configPath = '/trackTheBall/config/config.json';
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

//     // Using custom button press event that the Phidget handler fires to trigger the keydown event
//     window.ipc.on('button-press', (e, channel) => {
//         const snakeGameContainer = document.querySelector('.snake-game-container');

//         const keyboardEvent = document.createEvent("Event");

//         let keyCode = 0;
//         let key = '';

//         if (channel === 0) {
//             keyCode = 37;
//             key = 'ArrowLeft';
//         } else if (channel === 1) {
//             keyCode = 40;
//             key = 'ArrowDown';
//         } else if (channel === 2) {
//             keyCode = 38;
//             key = 'ArrowUp';
//         } else if (channel === 3) {
//             keyCode = 39;
//             key = 'ArrowRight';
//         }

//         keyboardEvent.initEvent('keydown', true, true);
//         keyboardEvent.keyCode = keyCode;
//         keyboardEvent.key = key;
//         window.dispatchEvent(keyboardEvent);

//         if (snakeGameContainer) {
//             snakeGameContainer.dispatchEvent(keyboardEvent);
//         }
//     });
// }

// if (window.ipc) {

//     // Fix The Machine start button handlers (spacebar and phidget support)
//     window.addEventListener('keydown', (e) => {
//         if (e.code === 'Space') {
//             const startButtonEvent = new Event('start-button-press');
//             window.dispatchEvent(startButtonEvent);
//         }
//     })

//     window.ipc.on('start-button-press', () => {
//         const startButtonEvent = new Event('start-button-press');
//         window.dispatchEvent(startButtonEvent);
//     })
// }
// Load config data when running in dev mode
if (configPath) {
    fetch(configPath)
        .then(res => res.json())
         .then(data => {
             data.startUrl = '/';
             data.configPath = configPath;
             ReactDOM.render(<App config={data} />, document.getElementById('root'));
     })
}
// // Load config data when running in dev mode
// if (configPath) {
//     fetch(configPath)
//         .then(res => res.json())
//         .then(data => {
//             data.startUrl = '/';
//             data.configPath = configPath;
//             ReactDOM.render(<App config={data} />, document.getElementById('root'));
//     })
// }

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()